import React from "react";

import FileIcon from "./FileIcon";
import { useTranslation } from "react-i18next";

export default function FilePreview({

    url,
    fileName

}) {
    const { t } = useTranslation();
    //--------------------------------------------------
    // Aucun fichier
    //--------------------------------------------------

    if (!fileName) {

        return null;

    }


    //--------------------------------------------------
    // Extension
    //--------------------------------------------------

    const extension =

        fileName
            .substring(
                fileName.lastIndexOf(".")
            )
            .toLowerCase();


    //--------------------------------------------------
    // Images
    //--------------------------------------------------

    const imageExtensions = [

        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".bmp",
        ".svg",
        ".webp"

    ];


    //--------------------------------------------------
    // Vidéos
    //--------------------------------------------------

    const videoExtensions = [

        ".mp4",
        ".avi",
        ".mov",
        ".webm",
        ".ogg",
        ".mkv"

    ];


    //--------------------------------------------------
    // IMAGE
    //--------------------------------------------------

    if (

        imageExtensions.includes(extension)

    ) {

        return (

            <img

                src={url}

                alt={fileName}

                className="
                    img-fluid
                    rounded
                    border
                    shadow-sm
                "

                style={{

                    width: "100%",
                    maxHeight: "650px",
                    objectFit: "contain",
                    cursor: "zoom-in",
                    backgroundColor: "#fafafa"

                }}

                onClick={() =>

                    window.open(
                        url,
                        "_blank"
                    )

                }

            />

        );

    }


    //--------------------------------------------------
    // VIDEO
    //--------------------------------------------------

    if (

        videoExtensions.includes(extension)

    ) {

        return (

            <video

                controls

                className="
                    w-100
                    rounded
                    border
                    shadow-sm
                "

                style={{

                    maxHeight: "600px",
                    backgroundColor: "#000"

                }}

            >

                <source src={url} />

                Votre navigateur ne supporte pas la lecture vidéo.

            </video>

        );

    }


    //--------------------------------------------------
    // DOCUMENTS
    //--------------------------------------------------

    return (

        <div className="card border shadow-sm">

            <div className="card-body">

                <div
                    className="
                    d-flex
                    justify-content-between
                    align-items-center
                    flex-wrap
                    "
                >

                    <div
                        className="
                        d-flex
                        align-items-center
                        "
                    >

                        <FileIcon

                            fileName={fileName}

                            size="2.7rem"

                        />


                        <div className="ms-3">

                            <div className="fw-bold">

                                {fileName}

                            </div>

                            <small className="text-muted">

                                Document joint

                            </small>

                        </div>

                    </div>


                    <a

                        href={url}

                        target="_blank"

                        rel="noreferrer"

                        download

                        className="
                            btn
                            btn-outline-primary
                            mt-2
                        "

                    >

                        <i className="bi bi-download me-2"></i>

                        {t("button.download")}

                    </a>

                </div>

            </div>

        </div>

    );

}